export class EntProcessingCapacityFilter {
  page: number;
  size: number;
  deleted: boolean;
  orgName: string;
  pin: string;
  regionId?: number;
  areaId?: number;
  territorialUnitId?: number;

  constructor(init?: Partial<EntProcessingCapacityFilter>) {
	this.orgName = '';
	this.pin = '';
	this.page = 1;
	this.size = 30;
	this.deleted = false;
	if (init) {
	  Object.assign(this, init)
	}
  }
}
